<div class="body">  
  <div class="content">
      <div [hidden]="!isError" class="error">
        An error occurred contacting Klyant: <strong>{{errorMessage}}</strong>
      </div>
      <div [hidden]="isError" class="message">
        Logged into Klyant. Please <input type="button" (click)="closeWindow()" value="Close" /> this window to continue.
      </div>   
  </div>































</div>
